import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_FAILURE:
        "AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_FAILURE",
    AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_REQUEST:
        "AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_REQUEST",
    AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_SUCCESS:
        "AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_SUCCESS",
    AUDIT_RESEND_AUDIT_EMAIL_POST_FAILURE:
        "AUDIT_RESEND_AUDIT_EMAIL_POST_FAILURE",
    AUDIT_RESEND_AUDIT_EMAIL_POST_REQUEST:
        "AUDIT_RESEND_AUDIT_EMAIL_POST_REQUEST",
    AUDIT_RESEND_AUDIT_EMAIL_POST_SUCCESS:
        "AUDIT_RESEND_AUDIT_EMAIL_POST_SUCCESS"
};

export const actionCreators = {
    getRequest: (ids) => ({
        type: actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_REQUEST,
        payload: ids,
        [WAIT_FOR_ACTION]:
            actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_FAILURE
    }),
    getSuccess: () => ({
        type: actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_SUCCESS
    }),
    getFailure: (error) => ({
        type: actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_FAILURE,
        error
    }),
    postRequest: (audits) => ({
        type: actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_FAILURE,
        payload: { audits }
    }),
    postSuccess: (audits) => ({
        type: actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_SUCCESS,
        payload: { audits }
    }),
    postFailure: (error) => ({
        type: actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_FAILURE,
        error
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
